import React, { useEffect, useState } from 'react';
import useApi from '../Utils/useApi';
import useCoreApi from '../Utils/useCoreApi';
import AppBar from '@mui/material/AppBar';
import Button from '@mui/material/Button';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { DataGrid } from '@mui/x-data-grid';
import IconButton from '@mui/material/IconButton';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useNavigate } from 'react-router-dom';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, TextField, Table, TableCell,
TableContainer, TableBody, Paper, TableHead, TableRow, Badge, Chip } from '@mui/material';
import NotificationIcon from './NotificationIcon';
import UserGreeting from './UserGreeting';
import QuizResultsTable from './QuizResultsTable';


// TODO remove, this demo shouldn't need to reset the theme.
const defaultTheme = createTheme();

const ParentDashboard = () => {
  const navigate = useNavigate();
  const [students, setStudents] = useState([]);
  const [studentProgress, setStudentProgress] = useState({});
  const parent_id = localStorage.getItem('user_id');
  const access_token = localStorage.getItem('accessToken');
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [chatEnabled, setChatEnabled] = useState(false);
  const [timeFrame, setTimeFrame] = useState('7');
  const [weeklyLessonMetrics, setWeeklyLessonMetrics] = useState({});
  const [weeklyAvgScores, setWeeklyAvgScores] = useState({});
  const [error, setError] = useState(null);
  const [studentUsername, setStudentUsername] = useState("");
  const [newUsername, setNewUsername] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [selectedLesson, setSelectedLesson] = useState(null);
  const api = useApi();
  const coreApi = useCoreApi();
  const [leagueData, setLeagueData] = useState(null);
  const [subscriptions, setSubscriptions] = useState([]);
  const [quizResultsOpen, setQuizResultsOpen] = useState(false);
  const [quizResults, setQuizResults] = useState([]);
  const [loadingQuizResults, setLoadingQuizResults] = useState(false);
  const [loadingSubId, setLoadingSubId] = useState(null);
  // Safeguarding alerts state
  const [safeguardingAlerts, setSafeguardingAlerts] = useState([]);
  const [loadingAlerts, setLoadingAlerts] = useState(false);
  const [wellbeingModalOpen, setWellbeingModalOpen] = useState(false);
  const subjectMapping = {
    '1': { title: 'Maths', color: '#0303fd' },
    '2': { title: 'Science', color: '#00b333' },
    '3': { title: 'Geography', color: '#de8d00' },
    '4': { title: 'History', color: '#ba00b3' },
    '5': { title: 'English', color: '#c10000' },
    '6': { title: 'ICT', color: '#848484' },
    '7': { title: 'Business Studies', color: '#848484' },    
  };
  const [expandedAccordion, setExpandedAccordion] = useState(null);

  const handleAccordionChange = (subject) => (event, isExpanded) => {
    setExpandedAccordion(isExpanded ? subject : false);
  };

  const handleRowClick = (param) => {
    setSelectedLesson(param.row);
  };

  const handleClose = () => {
    setSelectedLesson(null);
  };

  const handleToggleAutoRenew = async (subscriptionId) => {
    const subscription = subscriptions.find(sub => sub.id === subscriptionId);
    if (!subscription) return;

    if (subscription.recurring) {
      setLoadingSubId(subscriptionId);
      try {
        const response = await coreApi.post('/subscription/toggleautorenew', {
          userId: selectedStudent
        }, {
          headers: { 'Authorization': `Bearer ${access_token}` }
        });
        alert(response.data.message);

        // 🔑 Refresh the subscriptions list after update
        await fetchSubscriptions(selectedStudent);

      } catch (err) {
        console.error("Error toggling auto-renew:", err);
        alert("Error toggling auto-renew. Please try again.");
      } finally {
        setLoadingSubId(null);
      }
    } else {
      alert("Auto-renew is already disabled for this subscription. A new subscription will need to be purchased.");
    }
  };
  
  
  
  
  

  const handleOpenQuizResults = async () => {
    setLoadingQuizResults(true);
    setQuizResultsOpen(true);
    try {
      const res = await coreApi.get(`/quiz/student_results/${selectedStudent}`, {
        headers: { 'Authorization': `Bearer ${access_token}` }
      });
      setQuizResults(res.data);
    } catch (err) {
      setQuizResults([]);
      alert("Could not load quiz results!");
      console.error(err);
    }
    setLoadingQuizResults(false);
  };
  
  const handleReport = (row) => {
    alert(`Reporting issue for Question ID: ${row.question_id}\n\n(You can wire this up to an API later!)`);
  };
  

      // Fetch students and their chat settings
      useEffect(() => {
        api.get(`/user/students/${parent_id}`, {
            headers: {
                'Authorization': `Bearer ${access_token}`
            }
        })
        .then(res => {
            setStudents(res.data);
            if (res.data.length > 0) {
                setSelectedStudent(res.data[0].id);
                setChatEnabled(res.data[0].chat_enabled);
            }
        })
        .catch(err => console.log(err));
    }, [parent_id, access_token]);

    // Update chat setting for the selected student
    const handleToggleChat = () => {
        api.put(`/user/chat-settings/${selectedStudent}`, {
            chat_enabled: !chatEnabled
        }, {
            headers: {
                'Authorization': `Bearer ${access_token}`
            }
        })
        .then(res => {
            alert(res.data.msg);
            setChatEnabled(!chatEnabled);  // Toggle chatEnabled state
        })
        .catch(err => {
            console.error("Error updating chat settings:", err);
            alert("Failed to update chat settings.");
        });
    };

    // Fetch safeguarding alerts for parent's children
    const fetchSafeguardingAlerts = async () => {
      setLoadingAlerts(true);
      try {
        const response = await fetch('https://whale-app-6qyfq.ondigitalocean.app/api/parent/safeguarding-alerts', {
          headers: { 'Authorization': `Bearer ${access_token}` }
        });
        const data = await response.json();
        if (data.success) {
          setSafeguardingAlerts(data.alerts);
        }
      } catch (error) {
        console.error('Error fetching safeguarding alerts:', error);
      } finally {
        setLoadingAlerts(false);
      }
    };

    // Mark alert as reviewed
    const handleMarkAlertReviewed = async (alertId) => {
      try {
        const response = await fetch(`https://whale-app-6qyfq.ondigitalocean.app/api/parent/safeguarding-alerts/${alertId}/reviewed`, {
          method: 'POST',
          headers: { 'Authorization': `Bearer ${access_token}` }
        });
        const data = await response.json();
        if (data.success) {
          // Update local state
          setSafeguardingAlerts(prev => prev.map(alert =>
            alert.id === alertId ? { ...alert, reviewed: true } : alert
          ));
        }
      } catch (error) {
        console.error('Error marking alert as reviewed:', error);
      }
    };

    // Fetch safeguarding alerts on mount
    useEffect(() => {
      if (access_token) {
        fetchSafeguardingAlerts();
      }
    }, [access_token]);

  useEffect(() => {
    setNewUsername("");
    setNewPassword("");
  }, [selectedStudent]);

// Helper function to refresh subscriptions
const fetchSubscriptions = async (studentId) => {
  try {
    const response = await api.get(`/subscription/subscription/user/${studentId}`, {
      headers: { 'Authorization': `Bearer ${access_token}` }
    });
    setSubscriptions(response.data);
  } catch (error) {
    console.error('Error fetching subscription data:', error.message);
  }
};



  useEffect(() => {
    const student = students.find(s => s.id === selectedStudent);
    if (student) {
        setStudentUsername(student.username);
    }
  }, [selectedStudent, students]);

  const handleUpdateCredentials = () => {
    if (!newUsername && !newPassword) {
        setError("Please enter a new username or password to update.");
        return;
    }

    api.post(`/user/student/${selectedStudent}/update`, {
        username: newUsername,
        password: newPassword
    }, {
        headers: {
            'Authorization': `Bearer ${access_token}`
        }
    })
    .then(res => {
        if (res.data && res.data.msg) {
            alert(res.data.msg);
            if (newUsername) {
                setStudentUsername(newUsername);  // Update the displayed username
                setNewUsername("");  // Clear the input field
            }
            setNewPassword("");  // Clear the password input field
        }
    })
    .catch(err => {
        // Check if there's a response from the server with a message
        if (err.response && err.response.data && err.response.data.msg) {
            setError(err.response.data.msg);  // Display the error message from the server
        } else {
            setError("An unexpected error occurred.");
        }
        console.log(err);
    });
  };

// DATA EXPORT FUNCTION SECTION  

// Data Export state
const [exportDialogOpen, setExportDialogOpen] = useState(false);
const [exportStartDate, setExportStartDate] = useState("");
const [exportEndDate, setExportEndDate] = useState("");

// Helper to format dates as "yyyy-mm-dd"
const formatDate = (d) => d.toISOString().split('T')[0];

// Helper function to download CSV with authorization header
const downloadCSV = async (url) => {
  try {
    const response = await fetch(url, {
      headers: {
        'Authorization': `Bearer ${access_token}`,
      },
    });
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    const blob = await response.blob();
    const downloadUrl = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = downloadUrl;
    a.download = 'progress_export.csv';
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(downloadUrl);
  } catch (error) {
    console.error("Download error: ", error);
    alert("Error downloading CSV");
  }
};

// Quick export handler for preset options
const handleQuickExport = (option) => {
  const today = new Date();
  let start, end;
  if (option === 'lastWeek') {
    // Last 7 days
    start = new Date();
    start.setDate(today.getDate() - 7);
    end = new Date();
  } else if (option === 'lastMonth') {
    // Last 30 days
    start = new Date();
    start.setDate(today.getDate() - 30);
    end = new Date();
  } else if (option === 'last3months') {
    // Last 90 days
    start = new Date();
    start.setDate(today.getDate() - 90);
    end = new Date();
  }
  const s = formatDate(start);
  const e = formatDate(end);
  setExportStartDate(s);
  setExportEndDate(e);
  const url = `https://rl-core-app-kpx3b.ondigitalocean.app/progress/export?user_id=${selectedStudent}&start_date=${s}&end_date=${e}`;
  downloadCSV(url);
};

// Handler for custom export once dates are selected
const handleCustomExport = () => {
  if (exportStartDate && exportEndDate) {
    const url = `https://rl-core-app-kpx3b.ondigitalocean.app/progress/export?user_id=${selectedStudent}&start_date=${exportStartDate}&end_date=${exportEndDate}`;
    downloadCSV(url);
    setExportDialogOpen(false);
  } else {
    alert("Please select both start and end dates");
  }
};


//END OF DATA EXPORT FUNCTION SECTION



  useEffect(() => {
    if (selectedStudent) {
        api.get(`/subscription/subscription/user/${selectedStudent}`, {
            headers: {
                'Authorization': `Bearer ${access_token}`
            }
        })
        .then(response => {
            setSubscriptions(response.data);
        })
        .catch(error => {
            console.error('Error fetching subscription data:', error.message);
        });
    }
  }, [selectedStudent, access_token]);

  useEffect(() => {
    if (selectedStudent) {
      const student = students.find(s => s.id === selectedStudent);
      if (student) {
        console.log("Updating chatEnabled state:", student.chat_enabled);
        setChatEnabled(student.chat_enabled);
        setStudentUsername(student.username);
      }
    }
  }, [selectedStudent, students]);
  

  useEffect(() => {
    let isMounted = true; // to track whether the component is mounted

    if (selectedStudent) {
        api.get(`/rfleague/get-student-current-league/${selectedStudent}`, {
            headers: {
                'Authorization': `Bearer ${access_token}`
            }
        })
        .then(res => {
            if (isMounted) { // only update state if component is still mounted
                setLeagueData(res.data);
            }
        })
        .catch(err => {
            console.log(err);
            if (isMounted) {
                setLeagueData(null);
            }
        });
    }




    
    return () => {
        isMounted = false; // cleanup: mark the component as unmounted
    };
  }, [selectedStudent, access_token]);

  useEffect(() => {
    if (!access_token) {
        return;
    }

    // Fetch list of students for the parent
    api.get(`/user/students/${parent_id}`, {
        headers: {
            'Authorization': `Bearer ${access_token}`
        }
    })
    .then(res => {
        setStudents(res.data);
        
        // Set the first student as the selected student by default
        if (res.data && res.data.length > 0 && !selectedStudent) {
            setSelectedStudent(res.data[0].id);
            setStudentUsername(res.data[0].username);
        }
    })
    .catch(err => console.log(err));
  }, [parent_id, access_token]);

  useEffect(() => {
    if (!access_token || !selectedStudent) {
        return;
    }

    // Fetch progress data for the selected student based on the current time frame
    api.get(`/progress/student-progress/${selectedStudent}?days=${timeFrame}`, {
        headers: {
            'Authorization': `Bearer ${access_token}`
        }
    })
    .then(res => {
        if (res.data) {
            // Convert "Completed Time" to JavaScript Date objects for easy sorting
            for (let subject in res.data) {
              res.data[subject].sort((a, b) => new Date(b['Completed Time']) - new Date(a['Completed Time']));  // Sort by Completed Time in descending order
            }
        }
        
        setStudentProgress(prevState => ({
            ...prevState,
            [selectedStudent]: res.data
        }));
      })
      .catch(err => {
          console.error("Error fetching student progress:", err);
    });
  }, [selectedStudent, timeFrame, access_token]);

  useEffect(() => {
      if (!access_token) {
          return;
      }

    // Fetching weekly lesson metrics
    api.get('/metrics/dashboard/dayweekcount', {
      headers: {
          'Authorization': `Bearer ${access_token}`
      }
    })
    .then(response => {
        const data = response.data;
        setWeeklyLessonMetrics(data);
    })
    .catch(error => {
        console.error('Error fetching weekly lesson metrics:', error.message);
    });

    // Fetching weekly average scores
    api.get('/metrics/dashboard/avgscores', {
        headers: {
            'Authorization': `Bearer ${access_token}`
        }
    })
    .then(response => {
        const data = response.data;  // Extract the data from the response
        setWeeklyAvgScores(data);
    })
    .catch(error => {
        console.error('Error fetching weekly average scores:', error.message);
    });
  }, [access_token]);

  const selectedStudentAvgScores = weeklyAvgScores[selectedStudent] || {};
  const avgScoresData = Object.keys(selectedStudentAvgScores).map(date => {
    return {
      name: date,
      ...selectedStudentAvgScores[date]
    };
  });

  const selectedStudentMetrics = weeklyLessonMetrics[selectedStudent] || {};
  const formattedData = Object.keys(selectedStudentMetrics).map(date => {
    return {
      name: date,
      ...selectedStudentMetrics[date]
    };
  });

  const allSubjects = new Set();
  Object.values(selectedStudentMetrics).forEach(subjects => {
    Object.keys(subjects).forEach(subject => allSubjects.add(subject));
  });

  const LeagueBox = () => {
    if (!leagueData) return null; // don't render anything if there's no league data

    return (
      <Box style={{ border: '1px solid #ccc', padding: '20px', marginRight: '335px', textAlign: 'center' }}>
        <Typography variant="h6" gutterBottom align="center">
          {studentUsername}'s League
        </Typography>
        <Typography variant="h6" gutterBottom align="center">
          {leagueData.league_name}
        </Typography>
        <img src={leagueData.imgURL} alt={leagueData.league_name} style={{ maxWidth: '100%' }} />
      </Box>
    );
  };

  const handleAddSubscription = () => {
    const studentDetails = students.find(student => student.id === selectedStudent);
    if (studentDetails) {
      navigate('/checkout', { state: { student: studentDetails } });
    } else {
      alert('Please select a student first.');
    }
  };

  const handleTimeFrameChange = (event) => {
    setTimeFrame(event.target.value);
  };

  const handleRegister = () => {
    window.location.href = "/StudentRegistration";
  };

  const handleLogin = () => {
    window.location.href = "/ParentLogin"; 
  };

  if (!access_token) {
    return (
      <ThemeProvider theme={defaultTheme}>
        <AppBar position="relative">
          <Toolbar>
            <IconButton edge="start" color="inherit" aria-label="back">
              <ArrowBackIosIcon />
            </IconButton>
            <Typography variant="h6" color="inherit" noWrap>
              Parent Dashboard
            </Typography>
          </Toolbar>
        </AppBar>
        <Box sx={{ bgcolor: 'background.paper', pt: 8, pb: 6 }}>
          <Container maxWidth="sm">
            <Typography variant="h5" align="center" color="text.secondary" paragraph>
              Please log in to see the parent dashboard
            </Typography>
            <Button variant="contained" onClick={handleLogin}>Log in</Button>
          </Container>
        </Box>
      </ThemeProvider>
    );
  }

  return (
    <ThemeProvider theme={defaultTheme}>
      <AppBar
        position="static" // Changed from "relative" to "static" to match the other AppBar
        color="default" // Set to "default" to get the grey color
        elevation={0} // Set to 0 to remove the shadow for a flat appearance
        sx={{ borderBottom: (theme) => `1px solid ${theme.palette.divider}` }} // Adding the borderBottom style if needed
      >
        <Toolbar>
          <IconButton edge="start" color="inherit" aria-label="back" onClick={() => { console.log("Clicked!"); navigate('/RLBlog'); }}>
            <ArrowBackIosIcon />
          </IconButton>
          <Typography variant="h6" color="inherit" noWrap>
            Parent Dashboard
          </Typography>
          <Box flexGrow={1}></Box> {/* This pushes the subsequent content to the right */}
          <Box mr={2}> {/* Applying margin to the right of the button */}
            <Button color="success" variant="contained" onClick={handleRegister}> {/* Changed to "outlined" and "inherit" color */}
              Register New Student
            </Button>
          </Box>
          <UserGreeting />
        </Toolbar>
      </AppBar> 
      <Grid container spacing={3} style={{ padding: '20px' }}>
        {/* Student selection sidebar */}
        <Grid item xs={3}>
          <Typography variant="h6" align="center" gutterBottom>
            Select Student
          </Typography>
          <List>
            {students.map((student) => (
              <ListItem 
                button 
                onClick={() => setSelectedStudent(student.id)} 
                key={student.id}
                selected={selectedStudent === student.id}
              >
                <ListItemText primary={`${student.firstname} ${student.lastname}`} />
              </ListItem>
            ))}
          </List>
        </Grid>
  
        {/* Data area for the selected student */}
        <Grid item xs={9}>
          {/* Subscription section */}
          <Box mb={3} bgcolor="#f5f5f5" borderRadius="8px" p={2}> {/* Styled Box */}
            <Typography variant="h6" gutterBottom>Subscription</Typography>
            {subscriptions.length === 0 ? (
              <Typography variant="body1">No subscriptions found for the selected student.</Typography>
            ) : (
<Box maxWidth="60%">
  <TableContainer 
    component={Paper}
    elevation={3}
    sx={{ 
      borderRadius: '12px', 
      overflow: 'hidden', // keeps the table corners clipped
    }}
  >
    <Table size="small">
      <TableHead>
        <TableRow sx={{ backgroundColor: '#e3f2fd' }}>
          <TableCell sx={{ fontWeight: 700 }}>Type</TableCell>
          <TableCell sx={{ fontWeight: 700 }}>Start Date</TableCell>
          <TableCell sx={{ fontWeight: 700 }}>Expiry Date</TableCell>
          <TableCell sx={{ fontWeight: 700 }}>Status</TableCell>
          <TableCell sx={{ fontWeight: 700 }}>Auto Renew</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {subscriptions.map((sub, index) => (
          <TableRow 
            key={sub.id}
            sx={{
              backgroundColor: index % 2 === 0 ? '#fafafa' : '#fff',
              '&:hover': { backgroundColor: '#f1f9ff' },
              transition: 'background-color 0.3s ease'
            }}
          >
            <TableCell>{sub.subscription_type}</TableCell>
            <TableCell>{new Date(sub.start_date).toLocaleDateString()}</TableCell>
            <TableCell>{new Date(sub.end_date).toLocaleDateString()}</TableCell>
            <TableCell>{sub.status}</TableCell>
            <TableCell>
              <Button
                variant="contained"
                color={sub.recurring ? "secondary" : "inherit"}
                onClick={() => handleToggleAutoRenew(sub.id)}
                disabled={!sub.recurring || loadingSubId === sub.id}
              >
                {loadingSubId === sub.id
                  ? "Updating..."
                  : sub.recurring
                    ? "Turn Off Auto-Renew"
                    : "Auto Renew is OFF"}
              </Button>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </TableContainer>
</Box>

            )}
  {/* 🔥 Pay for subscription button back where it belongs */}
  <Box display="flex" gap={2} mt={2}>
    <Button variant="contained" onClick={handleAddSubscription}>
      Subscription Payment
    </Button>
  </Box>
</Box>

          

{/* Chat Settings & Wellbeing Alerts for the selected student */}
<Box mb={3} bgcolor="#f5f5f5" borderRadius="8px" p={2}>
  <Typography variant="h6" gutterBottom>
    Chat Settings for {studentUsername || 'Selected Student'}
  </Typography>
  <Typography variant="body1" gutterBottom>
    Chat is currently {chatEnabled ? 'Enabled' : 'Disabled'}.
  </Typography>
  <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', alignItems: 'center', mt: 2 }}>
    <Button
      variant="contained"
      color={chatEnabled ? 'secondary' : 'primary'}
      onClick={handleToggleChat}
    >
      {chatEnabled ? 'Disable Chat' : 'Enable Chat'}
    </Button>

    {/* Wellbeing Alerts Button */}
    {safeguardingAlerts.filter(a => !a.reviewed).length > 0 ? (
      <Badge badgeContent={safeguardingAlerts.filter(a => !a.reviewed).length} color="error">
        <Button
          variant="contained"
          sx={{ bgcolor: '#ed6c02', '&:hover': { bgcolor: '#e65100' } }}
          onClick={() => setWellbeingModalOpen(true)}
          startIcon={<span role="img" aria-label="alert">⚠️</span>}
        >
          Wellbeing Alerts
        </Button>
      </Badge>
    ) : safeguardingAlerts.length > 0 ? (
      <Button
        variant="outlined"
        size="small"
        onClick={() => setWellbeingModalOpen(true)}
      >
        View Alert History
      </Button>
    ) : null}
  </Box>
</Box>

{/* Wellbeing Alerts Modal */}
<Dialog
  open={wellbeingModalOpen}
  onClose={() => setWellbeingModalOpen(false)}
  maxWidth="md"
  fullWidth
>
  <DialogTitle sx={{ bgcolor: '#fff3e0', borderBottom: '1px solid #ffb74d' }}>
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <span role="img" aria-label="alert">⚠️</span> Wellbeing Alerts
    </Box>
    <Typography variant="body2" color="textSecondary" sx={{ mt: 1 }}>
      Our chat safety system monitors for signs that your child may need extra support.
    </Typography>
  </DialogTitle>
  <DialogContent sx={{ mt: 2 }}>
    {loadingAlerts ? (
      <Typography>Loading alerts...</Typography>
    ) : safeguardingAlerts.length === 0 ? (
      <Box sx={{ p: 3, textAlign: 'center' }}>
        <Typography variant="h6" color="success.main">
          <span role="img" aria-label="check">✓</span> No wellbeing alerts
        </Typography>
        <Typography variant="body2" color="textSecondary" sx={{ mt: 1 }}>
          No alerts in the last 30 days
        </Typography>
      </Box>
    ) : (
      <Box>
        {safeguardingAlerts.map(alert => {
          const severity = (alert.severityLevel || '').toLowerCase();
          const isCritical = severity === 'critical';
          const borderColor = isCritical ? '#f44336' : '#ff9800';
          const bgColor = isCritical ? '#ffebee' : '#fff8e1';
          const buttonColor = isCritical ? 'error' : 'warning';

          return (
            <Box
              key={alert.id}
              sx={{
                mb: 2,
                p: 2,
                bgcolor: alert.reviewed ? '#f5f5f5' : bgColor,
                borderRadius: 1,
                borderLeft: `4px solid ${borderColor}`,
                opacity: alert.reviewed ? 0.7 : 1
              }}
            >
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                <Box>
                  <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>
                    {alert.studentName}
                  </Typography>
                  <Typography variant="body2" sx={{ mt: 0.5 }}>{alert.type}</Typography>
                  <Typography variant="caption" color="textSecondary">
                    {new Date(alert.timestamp).toLocaleString('en-GB', { day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' })}
                  </Typography>
                </Box>
                {!alert.reviewed ? (
                  <Button size="small" variant="outlined" color={buttonColor} onClick={() => handleMarkAlertReviewed(alert.id)}>
                    Mark Reviewed
                  </Button>
                ) : (
                  <Chip label="Reviewed" size="small" color="success" variant="outlined" />
                )}
              </Box>
              {alert.messageContent && (
                <Box sx={{ mt: 1.5, p: 1.5, bgcolor: '#fff', borderRadius: 1, border: '1px solid #e0e0e0' }}>
                  <Typography variant="caption" color="textSecondary" sx={{ display: 'block', mb: 0.5 }}>Message sent:</Typography>
                  <Typography variant="body2" sx={{ fontStyle: 'italic' }}>"{alert.messageContent}"</Typography>
                </Box>
              )}
            </Box>
          );
        })}
      </Box>
    )}
  </DialogContent>
  <DialogActions>
    <Button onClick={() => setWellbeingModalOpen(false)}>Close</Button>
  </DialogActions>
</Dialog>

            {/* End of chat settings section */}

            {/* Data Export Section */}
<Box mb={3} bgcolor="#f5f5f5" borderRadius="8px" p={2}>
  <Typography variant="h6" gutterBottom>Progress Data Export (Download CSV)</Typography>
  <Box display="flex" gap={2} flexWrap="wrap">
    <Button variant="contained" onClick={() => handleQuickExport('lastWeek')}>
      Last 7 Days
    </Button>
    <Button variant="contained" onClick={() => handleQuickExport('lastMonth')}>
      Last 30 Days
    </Button>
    <Button variant="contained" onClick={() => handleQuickExport('last3months')}>
      Last 3 Months
    </Button>
    <Button variant="outlined" onClick={() => setExportDialogOpen(true)}>
      Custom Range
    </Button>
  </Box>
</Box>

<Box mb={3} bgcolor="#f5f5f5" borderRadius="8px" p={2}>
  <Typography variant="h6" gutterBottom>Lesson Quiz Results</Typography>
  <Button
    variant="contained"
    color="primary"
    onClick={handleOpenQuizResults}
    disabled={!selectedStudent}
  >
    View Lesson Quiz Results for {studentUsername || "Student"}
  </Button>
</Box>

  
          {/* Combined section for credentials and league information */}
          <Box mb={3} bgcolor="#f5f5f5" borderRadius="8px" p={2} display="flex" justifyContent="space-between"> {/* Main container Box */}
            {/* Change Username & Password section */}
            <Box bgcolor="#f5f5f5" borderRadius="8px" p={2} flexGrow={1} mr={2}> {/* Adjusted Box */}
              <Typography variant="h6" gutterBottom>Change Username & Password</Typography>
              <Box mt={2}>
                <Typography variant="subtitle1" gutterBottom>Current Username: {studentUsername}</Typography>
                {/* New Username Input */}
                <TextField
                  fullWidth
                  variant="outlined"
                  margin="normal"
                  type="text"
                  label="Enter New Username"
                  value={newUsername}
                  onChange={(e) => setNewUsername(e.target.value)}
                />
                {/* New Password Input */}
                <TextField
                  fullWidth
                  variant="outlined"
                  margin="normal"
                  type="password"
                  label="Enter New Password"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                />
                <Button variant="contained" color="primary" onClick={handleUpdateCredentials} style={{ marginTop: '16px' }}>
                  Update
                </Button>
                {/* Error Display */}
                {error && (
                  <Typography variant="body2" color="error" style={{ marginTop: '10px' }}>
                    {error}
                  </Typography>
                )}
              </Box>
            </Box>
  
            {/* LeagueBox section */}
            <Box bgcolor="#f5f5f5" borderRadius="8px" p={2}> {/* Adjusted Box */}
              <LeagueBox />
            </Box>
          </Box>
  
          {/* Graphs section */}
          <Box display="flex"  bgcolor="#f5f5f5" borderRadius="8px" justifyContent="space-between" mb={3}>
            <Box width="48%">
              <Typography variant="h6" gutterBottom>Lessons by Subject: Last 7 Days</Typography>
              <BarChart width={600} height={300} data={formattedData} margin={{top: 5, right: 5, left: 1, bottom: 5}}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" />
                <YAxis allowDecimals={false} />
                <Tooltip formatter={(value, name) => [value, subjectMapping[name]?.title || name]} />
                <Legend formatter={value => subjectMapping[value]?.title || value} />
                {[...allSubjects].map(subjectID => (
                  <Bar 
                    key={subjectID} 
                    dataKey={subjectID} 
                    name={subjectMapping[subjectID]?.title || subjectID}
                    fill={subjectMapping[subjectID]?.color || '#8884d8'} 
                  />
                ))}
              </BarChart>
            </Box>
            <Box width="48%">
              <Typography variant="h6" gutterBottom>Average Scores: Last 7 Days</Typography>
              <BarChart width={600} height={300} data={avgScoresData} margin={{top: 5, right: 30, left: 5, bottom: 5}}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" />
                <YAxis allowDecimals={false} domain={[0, 100]} />
                <Tooltip formatter={(value, name) => [value, subjectMapping[name]?.title || name]} />
                <Legend formatter={value => subjectMapping[value]?.title || value} />
                {[...allSubjects].map(subjectID => (
                  <Bar 
                    key={subjectID} 
                    dataKey={subjectID} 
                    name={subjectMapping[subjectID]?.title || subjectID}
                    fill={subjectMapping[subjectID]?.color || '#8884d8'} 
                  />
                ))}
              </BarChart>
            </Box>
          </Box>
  
          {/* Lessons section */}
          <Box my={2} mb={9}>
            <Box my={2} mb={3}>
              <Typography variant="h6" gutterBottom>Completed Lessons</Typography>
              <Typography variant="h7" gutterBottom>(Click a row for more information about the lesson completed.)</Typography>
            </Box>
            <Box mb={3}>
              <Typography variant="body1">Select Time Frame:</Typography>
              <Select value={timeFrame} onChange={handleTimeFrameChange}>
                <MenuItem value={'7'}>Last 7 Days</MenuItem>
                <MenuItem value={'30'}>Last 30 Days</MenuItem>
              </Select>
            </Box>
            {studentProgress[selectedStudent] && (
    <div style={{ width: '80%' }}>
      {Object.keys(studentProgress[selectedStudent]).map(subject => (
        <Accordion 
          key={subject} 
          onChange={handleAccordionChange(subject)}
          style={{ marginBottom: '10px' }}
        >
          <AccordionSummary 
            expandIcon={<ExpandMoreIcon />} 
            aria-controls="panel-content" 
            id="panel-header"
            style={{ backgroundColor: '#f5f5f5' }}
          >
            <Typography variant="h6" gutterBottom>{subject}</Typography>
          </AccordionSummary>
          <AccordionDetails>
            {expandedAccordion === subject && (
              <DataGrid 
                autoHeight 
                rowHeight={80}
                rows={studentProgress[selectedStudent][subject]} 
                columns={[
                  { field: 'Completed Time', headerName: 'Completed On', flex: 1 },
                  { field: 'Lesson Year', headerName: 'Lesson Year', flex: 1 },
                  { field: 'Topic', headerName: 'Topic', flex: 1 },
                  { field: 'Lesson Name', headerName: 'Lesson Name', flex: 1 },
                ]}
                onRowClick={handleRowClick}
                rowClassName="clickable-row"
                pageSize={10} 
              />
            )}
          </AccordionDetails>
        </Accordion>
      ))}
    </div>
  )}
</Box>
        </Grid>
      </Grid>
  
{/* Dialog for showing detailed lesson information */}
{selectedLesson && (
  <Dialog open={true} onClose={handleClose}>
    <DialogTitle>{selectedLesson['Lesson Name']}</DialogTitle>
    <DialogContent>
      <DialogContentText>
        <strong>Completed On:</strong> {selectedLesson['Completed Time']}
      </DialogContentText>
      <DialogContentText>
        <strong>Lesson Year:</strong> {selectedLesson['Lesson Year']}
      </DialogContentText>
      <DialogContentText>
        <strong>Topic:</strong> {selectedLesson['Topic']}
      </DialogContentText>
      <DialogContentText>
        <strong>Lesson Status:</strong> {selectedLesson['Lesson Status']}
      </DialogContentText>
      <DialogContentText>
        <strong>Summary:</strong> {selectedLesson['Summary']}
      </DialogContentText>
      <DialogContentText>
        <strong>Score:</strong> {selectedLesson['Score']}
      </DialogContentText>
      {/* Add any other fields as needed */}
    </DialogContent>
    <DialogActions>
      <Button onClick={handleClose} color="primary">Close</Button>
    </DialogActions>
  </Dialog>
)}
<Dialog
  open={quizResultsOpen}
  onClose={() => setQuizResultsOpen(false)}
  maxWidth="xl"
  fullWidth
>
  <DialogTitle>
    Quiz Results for {studentUsername}
  </DialogTitle>
  <DialogContent>
    {loadingQuizResults ? (
      <Typography>Loading...</Typography>
    ) : (
      <QuizResultsTable results={quizResults} onReport={handleReport} />
    )}
  </DialogContent>
  <DialogActions>
    <Button onClick={() => setQuizResultsOpen(false)} color="primary">Close</Button>
  </DialogActions>
</Dialog>



<Dialog
  open={exportDialogOpen}
  onClose={() => setExportDialogOpen(false)}
  disablePortal
>
  <DialogTitle>Custom Export Range</DialogTitle>
  <DialogContent>
    <DialogContentText>
      Please select the start and end dates for the data export.
    </DialogContentText>
    <TextField
      label="Start Date"
      type="date"
      fullWidth
      margin="normal"
      value={exportStartDate}
      onChange={(e) => setExportStartDate(e.target.value)}
      InputLabelProps={{ shrink: true }}
    />
    <TextField
      label="End Date"
      type="date"
      fullWidth
      margin="normal"
      value={exportEndDate}
      onChange={(e) => setExportEndDate(e.target.value)}
      InputLabelProps={{ shrink: true }}
    />
  </DialogContent>
  <DialogActions>
    <Button onClick={() => setExportDialogOpen(false)} color="secondary">
      Cancel
    </Button>
    <Button onClick={handleCustomExport} color="primary">
      Export
    </Button>
  </DialogActions>
</Dialog>


    </ThemeProvider>
  );

  

  
}

export default ParentDashboard;
